import { useEffect, useState } from 'react';
import type { JSX } from 'react';
import { SkeletonText } from '@taki/ui';
import type { TakiSdk } from '@taki/sdk';
import { MODELE_PAR_DEFAUT, pointsDeLExamen, resumeDeLExamen } from './examen.js';

/**
 * L'EXAMEN D'UNE AUTRE CONSULTATION, EN LECTURE (l'historique) : le resume
 * recalcule depuis ses points et ses constantes, comme le collegue le lit.
 */
export function ResumeDeLExamen({ sdk, consultationId }: { sdk: TakiSdk; consultationId: string }): JSX.Element | null {
  const [lignes, setLignes] = useState<string[] | null>(null);
  useEffect(() => {
    let vivant = true;
    void Promise.all([
      sdk.inspections.list({ type: 'examen', where: { 'customFields.consultationId': consultationId }, limit: 5 }),
      sdk.measurements.list({ type: 'constante', where: { careRecordId: consultationId }, limit: 50 }),
    ]).then(
      ([desExamens, desMesures]) => {
        if (!vivant) return;
        const valeurs: Record<string, number> = {};
        for (const m of desMesures) if (m.archivedAt == null) valeurs[m.metric] = m.value;
        setLignes(resumeDeLExamen(MODELE_PAR_DEFAUT, pointsDeLExamen(MODELE_PAR_DEFAUT, desExamens[0]?.checkpoints ?? []), valeurs));
      },
      () => vivant && setLignes([]),
    );
    return () => {
      vivant = false;
    };
  }, [sdk, consultationId]);
  if (lignes === null) return <SkeletonText lines={2} />;
  if (lignes.length === 0) return null;
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-semibold text-ink-500">Examen en liste</span>
      {lignes.map((ligne) => (
        <p key={ligne} className="text-sm text-ink-900">
          {ligne}
        </p>
      ))}
    </div>
  );
}
